"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _AxisRestriction_activationKeyX, _AxisRestriction_activationKeyY, _AxisRestriction_activationKeyZ, _AxisRestriction_activationKeyPlane, _AxisRestriction_drawingToolsManager, _AxisRestriction_planeRestriction, _AxisRestriction_active, _AxisRestriction_geometryMathManager, _AxisRestriction_priority;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxisRestriction = void 0;
const AbstractRestriction_1 = require("../../AbstractRestriction");
// #endregion Type aliases (1)
// #region Classes (1)
class AxisRestriction extends AbstractRestriction_1.AbstractRestriction {
    // #endregion Properties (8)
    // #region Constructors (1)
    constructor(drawingToolsManager, planeRestriction, properties) {
        super(drawingToolsManager, 'axis');
        // #region Properties (8)
        _AxisRestriction_activationKeyX.set(this, void 0);
        _AxisRestriction_activationKeyY.set(this, void 0);
        _AxisRestriction_activationKeyZ.set(this, void 0);
        _AxisRestriction_activationKeyPlane.set(this, void 0);
        _AxisRestriction_drawingToolsManager.set(this, void 0);
        _AxisRestriction_planeRestriction.set(this, void 0);
        _AxisRestriction_active.set(this, false);
        _AxisRestriction_geometryMathManager.set(this, void 0);
        _AxisRestriction_priority.set(this, 0);
        __classPrivateFieldSet(this, _AxisRestriction_drawingToolsManager, drawingToolsManager, "f");
        __classPrivateFieldSet(this, _AxisRestriction_planeRestriction, planeRestriction, "f");
        __classPrivateFieldSet(this, _AxisRestriction_geometryMathManager, drawingToolsManager.geometryMathManager, "f");
        __classPrivateFieldSet(this, _AxisRestriction_activationKeyX, (properties === null || properties === void 0 ? void 0 : properties.activationKeyX) || 'x', "f");
        __classPrivateFieldSet(this, _AxisRestriction_activationKeyY, (properties === null || properties === void 0 ? void 0 : properties.activationKeyY) || 'y', "f");
        __classPrivateFieldSet(this, _AxisRestriction_activationKeyZ, (properties === null || properties === void 0 ? void 0 : properties.activationKeyZ) || 'z', "f");
        __classPrivateFieldSet(this, _AxisRestriction_activationKeyPlane, (properties === null || properties === void 0 ? void 0 : properties.activationKeyPlane) || 'p', "f");
        __classPrivateFieldSet(this, _AxisRestriction_priority, (properties === null || properties === void 0 ? void 0 : properties.priority) || 1, "f");
    }
    // #endregion Constructors (1)
    // #region Public Getters And Setters (5)
    get active() {
        return __classPrivateFieldGet(this, _AxisRestriction_active, "f");
    }
    set active(value) {
        __classPrivateFieldSet(this, _AxisRestriction_active, value, "f");
        // if (this.#gridHelper) this.#gridHelper.visible = value;
    }
    get enabledEditable() {
        return this._enabledEditable;
    }
    get priority() {
        return __classPrivateFieldGet(this, _AxisRestriction_priority, "f");
    }
    set priority(value) {
        __classPrivateFieldSet(this, _AxisRestriction_priority, value, "f");
    }
    // #endregion Public Getters And Setters (5)
    // #region Public Methods (2)
    snap(ray, point, metaData) {
        if (this.enabled === false)
            return;
        if (!metaData || !metaData.referencePoint)
            return;
        const xPressed = __classPrivateFieldGet(this, _AxisRestriction_drawingToolsManager, "f").keyPressed(__classPrivateFieldGet(this, _AxisRestriction_activationKeyX, "f"));
        const yPressed = __classPrivateFieldGet(this, _AxisRestriction_drawingToolsManager, "f").keyPressed(__classPrivateFieldGet(this, _AxisRestriction_activationKeyY, "f"));
        const zPressed = __classPrivateFieldGet(this, _AxisRestriction_drawingToolsManager, "f").keyPressed(__classPrivateFieldGet(this, _AxisRestriction_activationKeyZ, "f"));
        const pPressed = __classPrivateFieldGet(this, _AxisRestriction_drawingToolsManager, "f").keyPressed('p');
        if (xPressed) {
            return __classPrivateFieldGet(this, _AxisRestriction_geometryMathManager, "f").closestPoint({ origin: metaData.referencePoint, direction: __classPrivateFieldGet(this, _AxisRestriction_planeRestriction, "f").vectorU }, point);
        }
        else if (yPressed) {
            return __classPrivateFieldGet(this, _AxisRestriction_geometryMathManager, "f").closestPoint({ origin: metaData.referencePoint, direction: __classPrivateFieldGet(this, _AxisRestriction_planeRestriction, "f").vectorV }, point);
        }
        else if (zPressed) {
            return __classPrivateFieldGet(this, _AxisRestriction_geometryMathManager, "f").closestPointsRayRay({ origin: metaData.referencePoint, direction: __classPrivateFieldGet(this, _AxisRestriction_planeRestriction, "f").normal }, ray).closestPointOnRay1;
        }
        else if (pPressed) {
            return __classPrivateFieldGet(this, _AxisRestriction_geometryMathManager, "f").closestPointOnPlane(__classPrivateFieldGet(this, _AxisRestriction_planeRestriction, "f").origin, __classPrivateFieldGet(this, _AxisRestriction_planeRestriction, "f").normal, point);
        }
    }
    updatePlaneDefinition() { }
    // #endregion Public Methods (2)
    // #region Protected Methods (1)
    visibilityChanged() { }
}
exports.AxisRestriction = AxisRestriction;
_AxisRestriction_activationKeyX = new WeakMap(), _AxisRestriction_activationKeyY = new WeakMap(), _AxisRestriction_activationKeyZ = new WeakMap(), _AxisRestriction_activationKeyPlane = new WeakMap(), _AxisRestriction_drawingToolsManager = new WeakMap(), _AxisRestriction_planeRestriction = new WeakMap(), _AxisRestriction_active = new WeakMap(), _AxisRestriction_geometryMathManager = new WeakMap(), _AxisRestriction_priority = new WeakMap();
// #endregion Classes (1)
//# sourceMappingURL=AxisRestriction.js.map